// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1v5Wp","title":"ClientReferral_title__3iENe","itemText":"ClientReferral_itemText__1ySBs"};